const splitNameParts = (value) =>
  String(value || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);

const getLastNameKey = (value) => {
  const parts = splitNameParts(value);
  if (!parts.length) return "";
  return parts[parts.length - 1].toLowerCase();
};

const getFullNameKey = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const compareSwimmerNamesByLastName = (nameA, nameB) => {
  const lastA = getLastNameKey(nameA);
  const lastB = getLastNameKey(nameB);

  const lastCompare = lastA.localeCompare(lastB, undefined, {
    sensitivity: "base",
  });
  if (lastCompare !== 0) return lastCompare;

  return getFullNameKey(nameA).localeCompare(getFullNameKey(nameB), undefined, {
    sensitivity: "base",
  });
};

export const compareSwimmerObjectsByName = (a, b, key = "name") =>
  compareSwimmerNamesByLastName(a?.[key], b?.[key]);
